export default {
  rankTrackerKeywords: {
    buttons: {
      cancel: "Cancel",
      save: "Save",
    },
    title: "Time to start tracking your rankings. Let's add some keywords for this website.",
  },
};
